module.exports = [
  'events.list.futures.partners.count',
  'events.list.futures.notpartners.count',
  'events.list.futures.partners.title.current',
  'events.list.futures.partners.title.upcoming',
  'events.list.futures.nonefound',
  'events.link.futures.to.past',
];
